// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-features-common-styles-___DebugLinks__DebugLinks___1MpR4 a{margin:3px 0}\n", ""]);
// Exports
exports.locals = {
	"DebugLinks": "src-features-common-styles-___DebugLinks__DebugLinks___1MpR4"
};
module.exports = exports;
